import { render, staticRenderFns } from "./InputBoolean.vue?vue&type=template&id=772a40cc&scoped=true&lang=html"
import script from "./InputBoolean.vue?vue&type=script&lang=js"
export * from "./InputBoolean.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772a40cc",
  null
  
)

export default component.exports